import { Component, Input, ViewEncapsulation } from '@angular/core';

import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GtmTrackingService } from '../../../core/services/gtmTracking/gtm-tracking.service';
import { LocaleService } from '../../../core/services/locale/locale.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { ServiceClosureService } from '../../../lazy-modules/serviceClosure/service-closure.service';
import { QuickbetPartialOverlayComponent } from '../../../quickbet/components/quickbetPartialOverlay/quickbet-partial-overlay.component';

@Component({
    selector: 'srm-quickbet-partial-overlay',
    templateUrl: 'srm-quickbet-partial-overlay.component.html',
    styleUrls: [
        '../../../quickbet/components/quickbetPartialOverlay/quickbet-partial-overlay.component.scss',
        'srm-quickbet-partial-overlay.component.scss',
    ],
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class SrmQuickbetPartialOverlayComponent extends QuickbetPartialOverlayComponent {
    @Input() selectionEventLocalTime: string;

    constructor(
        serviceClosureService: ServiceClosureService,
        gtmService: GtmService,
        gtmTrackingService: GtmTrackingService,
        protected windowRefService: WindowRefService,
        protected localeService: LocaleService,
    ) {
        super(serviceClosureService, gtmService, gtmTrackingService);
    }

    /**
     * Removes SRM selection on click of OK button
     * @returns {void}
     */
    public ok(): void {
        const gtmTrackObject = {
            'event': 'Event.Tracking',
            'component.CategoryEvent': 'horse racing',
            'component.LabelEvent': this.localeService.getString('racing.srmTabName').toLowerCase(),
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'error message overlay',
            'component.LocationEvent': this.selection.typeName + '/ ' + this.selectionEventLocalTime,
            'component.EventDetails': 'ok cta',
            'component.URLClicked': this.windowRefService.nativeWindow.location.href,
        };
        this.gtmService.push(gtmTrackObject.event, gtmTrackObject);
        this.removeSelectionFn.emit();
    }
}
